module.exports = __webpack_public_path__ + "static/img/team4.0a33891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team4.png
// module id = ch5O
// module chunks = 1